import { MinusOutlined, PlusOutlined } from '@ant-design/icons';
import { Button, Col, Flex, Form, FormInstance, Row, Select } from 'antd';
import { useWatch } from 'antd/es/form/Form';
import { useEffect, useRef, useState } from 'react';
import { useParams } from 'react-router';
import {
  FormInputItem,
  FormSelectInput,
  NumberInput,
} from '../../../../../components/common/FormItem/FormItems';
import {
  AutoComplete_input,
  SelectAirline,
  SelectEmployee,
  SelectGender,
  SelectItem,
} from '../../../../../components/common/FormItem/SelectCustomFeilds';
import { useGetAllClientCategoryQuery } from '../../../../Configuration/clientCategory/endpoints/clientCategoryEndpoints';
import { useGetInvoiceNoQuery } from '../../../../Invoice(Visa)/Api/Endpoints/invoiceVisaEndpoints';
import { useGetSingleClientsQuery } from '../../api/endpoints/clientEndpoints';
import { categoryChildren, typeChildren } from '../../utils/utils_tsx/utilAddClient';

type props = { form: FormInstance<any> };

const Client_Edit = ({ form }: props) => {
  const [corporateType, setcorporateType] = useState<boolean>(false);

  const opening_balance_type: 'Due' | 'Advance' = useWatch(['opening_balance_type'], form);

  const editMode = useRef(false);

  const { id } = useParams();
  const { isLoading, data: clientData } = useGetSingleClientsQuery(id as string);

  useEffect(() => {
    form.setFieldsValue({ client_category_id: 1 });
  }, []);

  const onCorporateType = (value: string) => {
    if (value == 'CORPORATE') {
      setcorporateType(true);
    } else if (value == 'INDIVIDUAL') {
      setcorporateType(false);
    }
  };

  const { data: clientCategories } = useGetAllClientCategoryQuery();

  // ITEMS INFO
  const items = [
    { label: 'Due', value: 'DEBIT' },
    { label: 'Advance', value: 'CREDIT' },
  ];

  if (!editMode.current) form.setFieldValue('client_walking_customer', 0);

  const { data: getInvoiceNo, isFetching } = useGetInvoiceNoQuery('CL', {
    skip: id ? true : false,
  });

  useEffect(() => {
    if (!id && getInvoiceNo?.data)
      form.setFieldsValue({
        client_entry_id: getInvoiceNo?.data?.replace('-', ''),
        ...clientData?.data,
      });
  }, [isFetching, getInvoiceNo]);
  useEffect(() => {
    if (editMode.current && clientData?.data) {
      form.setFieldsValue({
        ...clientData?.data,
        // Ensure client_airline_commissions is properly formatted
        client_airline_commissions:
          clientData?.data.client_airline_commissions?.length > 0
            ? clientData?.data.client_airline_commissions
            : [{}],
        client_gds_sign:
          clientData?.data.client_gds_sign?.length > 0 ? clientData?.data.client_gds_sign : [{}],
      });
    }
  }, [clientData?.data]);
  return (
    <>
      <div className='border p-5'>
        <Row gutter={[10, 0]}>
          <Col span={6} xs={24} sm={12} md={12} lg={6}>
            <Form.Item name={['client_category_id']} label='Client Category:'>
              <Select
                showSearch
                placeholder='Select a Category'
                optionFilterProp='children'
                filterOption={(input, option) =>
                  (option!.children as unknown as string)
                    ?.toLowerCase()
                    ?.includes(input?.toLowerCase())
                }
              >
                {clientCategories?.data && categoryChildren(clientCategories?.data)}
              </Select>
            </Form.Item>
          </Col>
          <FormInputItem required size={6} name={'client_entry_id'} label={'Client Id'} readOnly />
          <Col span={6} xs={24} sm={12} md={12} lg={6}>
            <Form.Item
              name={'client_type'}
              label='Client Type'
              rules={[{ required: true, message: 'Client Type is required' }]}
            >
              <Select
                showSearch
                placeholder='Select client type'
                optionFilterProp='typeChildren'
                onSelect={onCorporateType}
                filterOption={(input, option) =>
                  (option!.children as unknown as string)
                    .toLowerCase()
                    .includes(input.toLowerCase())
                }
              >
                {typeChildren}
              </Select>
            </Form.Item>
          </Col>

          <FormInputItem
            required
            size={6}
            name={'client_name'}
            label={corporateType ? 'Company name' : 'Name'}
          />

          <FormInputItem
            size={6}
            name={'client_email'}
            label={corporateType ? 'Company email' : 'Email'}
            inputType='email'
            rules={[
              {
                type: 'email',
                message: 'Please enter a valid email address',
              },
            ]}
          />

          {corporateType || <SelectGender size={6} name='client_gender' label='Gender' />}
          <FormInputItem
            size={6}
            name={'client_mobile'}
            label={corporateType ? 'Company mobile' : 'Mobile'}
          />
          <FormInputItem
            size={6}
            name={'client_address'}
            label={corporateType ? 'Company address' : 'Address'}
          />
          <SelectEmployee
            label={'Relationship Manager'}
            name='client_contacted_person'
            required
            size={6}
          />

          <SelectItem
            size={6}
            label='Walking Customer'
            name={'client_walking_customer'}
            items={[
              { label: 'No', value: 0 },
              { label: 'Yes', value: 1 },
            ]}
          />
          <SelectItem
            size={6}
            label='Client Payment Policy'
            name={'client_payment_policy'}
            items={[
              { label: 'Fortnight', value: 'Fortnight' },
              { label: 'Partial', value: 'Partial' },
            ]}
          />
          <AutoComplete_input
            size={6}
            label='Source'
            name={'client_source'}
            options={[
              'Existing Client',
              'Facebook Marketing',
              'Search Engine',
              'YouTube Marketing',
              'Direct Client',
              'Phone Call',
              'Linkedin',
              'Ads',
              'Agent',
              'Employee',
            ]}
          />

          <NumberInput
            size={6}
            name={'client_commission'}
            label={'Client commission'}
            placeholder={'Provide client commission'}
            maxChar={2}
          />
        </Row>
      </div>

      <div className='border p-5 mt-10'>
        <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 24 }}>
          <FormInputItem
            name={'client_designation'}
            label='Designation'
            smSize={12}
            mdSize={12}
            size={6}
          />

          <FormInputItem
            name={'client_trade_license'}
            label='Trade License No: '
            mdSize={12}
            size={6}
          />

          {/* Add Opening Balance */}
          <SelectItem
            disabled={editMode.current}
            name={'opening_balance_type'}
            label='Opening Balance type:'
            items={items}
            size={6}
          />

          {opening_balance_type && (
            <NumberInput
              required
              name={'opening_balance'}
              label='Opening Balance:'
              size={3}
              placeholder={'Opening Balance'}
            />
          )}
        </Row>
      </div>

      <div className='border p-5 mt-10'>
        <Form.List name='client_airline_commissions'>
          {(fields, { add, remove }) => (
            <>
              {fields.map(({ key, name, ...restField }) => (
                <Row
                  key={key}
                  gutter={{ xs: 8, sm: 16, md: 24, lg: 10 }}
                  style={{ marginBottom: 16 }}
                >
                  <SelectAirline
                    name={[name, 'ca_airline_id']}
                    size={6}
                    placeholder='Select Airline'
                    label='Select Airline'
                  />
                  <NumberInput
                    name={[name, 'ca_commission']}
                    size={6}
                    placeholder='Airline Commission'
                    label='Airline Commission'
                    maxChar={2}
                  />
                  <NumberInput
                    name={[name, 'ca_markup_charge']}
                    size={6}
                    placeholder='Markup Charge'
                    label='Markup Charge'
                  />
                  <FormInputItem
                    name={[name, 'ca_extra_discount']}
                    size={4}
                    placeholder='Extra Discount'
                    label='Extra Discount'
                  />
                  <Flex gap={6} style={{ marginTop: 30 }} align='center'>
                    {<Button danger icon={<MinusOutlined />} onClick={() => remove(name)} />}
                    <Button icon={<PlusOutlined />} onClick={() => add()} />
                  </Flex>
                </Row>
              ))}
              {fields.length === 0 && (
                <Button type='dashed' onClick={() => add()} block icon={<PlusOutlined />}>
                  Add Airline Commission
                </Button>
              )}
            </>
          )}
        </Form.List>
      </div>
      <div className='border p-5 mt-10'>
        <Form.List name='client_gds_sign'>
          {(fields, { add, remove }) => {
            const last_filed = fields[fields.length - 1]?.name;

            return (
              <>
                {fields.map(({ key, name }) => {
                  return (
                    <Row key={key} gutter={{ xs: 8, sm: 16, md: 24, lg: 10 }}>
                      <FormSelectInput
                        label='GDS'
                        name={[name, 'gds_name']}
                        size={8}
                        placeholder='Select GDS'
                        data={[
                          { name: 'Sabre', value: 'Sabre' },
                          { name: 'Amadeus', value: 'Amadeus' },
                          { name: 'Galileo', value: 'Galileo' },
                        ]}
                      />
                      <FormInputItem
                        name={[name, 'gds_epr']}
                        size={7}
                        placeholder='User Name'
                        label='User Name'
                      />
                      <FormInputItem
                        name={[name, 'gds_creation_sign']}
                        size={7}
                        placeholder='Creation Sign'
                        label='Creation Sign'
                      />
                      <Flex gap={6} style={{ marginTop: 30 }} align='center'>
                        {<Button danger icon={<MinusOutlined />} onClick={() => remove(name)} />}
                        <Button icon={<PlusOutlined />} onClick={() => add()} />
                      </Flex>
                    </Row>
                  );
                })}
                {fields.length === 0 && (
                  <Button type='dashed' onClick={() => add()} block icon={<PlusOutlined />}>
                    Add GDS Information
                  </Button>
                )}
              </>
            );
          }}
        </Form.List>
      </div>
    </>
  );
};

export default Client_Edit;
